import React from 'react';
import { Button } from '@/components/ui/button';
import { ChevronLeft, ChevronRight, Loader2 } from 'lucide-react';
import { TextContentSidebarContext } from '@/components/text-content-lightbox';
import { AppIdea } from '@/hooks/app-library';

export const AppIdeaNavigationButtons: React.FC<Pick<TextContentSidebarContext<AppIdea>, 'hasPrevious' | 'hasNext' | 'isLoadingMore' | 'onPrevious' | 'onNext'>> = ({
  hasPrevious,
  hasNext,
  isLoadingMore,
  onPrevious,
  onNext,
}) => {
  return (
    <div className="flex gap-2">
      <Button
        onClick={onPrevious}
        disabled={!hasPrevious}
        variant="outline"
        className="flex-1"
      >
        <ChevronLeft className="h-4 w-4 mr-2" />
        Previous
      </Button>
      <Button
        onClick={onNext}
        disabled={!hasNext && !isLoadingMore}
        variant="outline"
        className="flex-1"
      >
        {isLoadingMore ? (
          <Loader2 className="h-4 w-4 mr-2 animate-spin" />
        ) : (
          <ChevronRight className="h-4 w-4 mr-2" />
        )}
        {isLoadingMore ? 'Loading...' : 'Next'}
      </Button>
    </div>
  );
};
